import {
  GetPaymentsInfoAction,
  GetPaymentsInfoSuccessAction,
  GetPaymentsInfoFailureAction,
  IPaymentInfo,
  DeletePaymentMethodAction,
  DeletePaymentMethodSuccessAction,
  DeletePaymentMethodFailureAction,
  AddSubsToPaymentMethodAction,
  AddSubsToPaymentMethodSuccessAction,
  AddSubsToPaymentMethodFailureAction,
  SubscriptionsPaymentData
} from './paymentMethods.types';

export const getPaymentsInfoRequest = (): GetPaymentsInfoAction => ({
  type: 'GET_PAYMENTS_INFO_REQUEST'
});

export const getPaymentsInfoSuccess = (payload: IPaymentInfo[]): GetPaymentsInfoSuccessAction => ({
  type: 'GET_PAYMENTS_INFO_SUCCESS',
  payload
});

export const getPaymentsInfoFailure = (error: string): GetPaymentsInfoFailureAction => ({
  type: 'GET_PAYMENTS_INFO_FAILURE',
  error
});

export const deletePaymentMethodRequest = (payload: number): DeletePaymentMethodAction => ({
  type: 'DELETE_PAYMENT_METHOD_REQUEST',
  payload
});

export const deletePaymentMethodSuccess = (payload: number): DeletePaymentMethodSuccessAction => ({
  type: 'DELETE_PAYMENT_METHOD_SUCCESS',
  payload
});

export const deletePaymentMethodFailure = (error: string): DeletePaymentMethodFailureAction => ({
  type: 'DELETE_PAYMENT_METHOD_FAILURE',
  error
});

export const addSubsToPaymentInfoRequest = (
  payload: SubscriptionsPaymentData
): AddSubsToPaymentMethodAction => ({
  type: 'ADD_SUBS_TO_PAYMENT_METHOD_REQUEST',
  payload
});

export const addSubsToPaymentInfoSuccess = (
  payload: SubscriptionsPaymentData
): AddSubsToPaymentMethodSuccessAction => ({
  type: 'ADD_SUBS_TO_PAYMENT_METHOD_SUCCESS',
  payload
});

export const addSubsToPaymentInfoFailure = (
  error: string
): AddSubsToPaymentMethodFailureAction => ({
  type: 'ADD_SUBS_TO_PAYMENT_METHOD_FAILURE',
  error
});
